import { defineComponent as o, openBlock as r, createBlock as n, normalizeProps as a, guardReactiveProps as p, withCtx as c, renderSlot as l, createElementVNode as s } from "vue";
import d from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ s("path", {
  role: "presentation",
  d: "M12 16c.273 0 .521-.11.702-.288l5.005-5.005a1 1 0 00-1.414-1.414L12 13.586 7.705 9.29a1 1 0 00-1.412 1.417l4.98 4.98c.182.193.44.313.727.313z"
}, null, -1), f = /* @__PURE__ */ o({
  name: "CaretDown",
  __name: "caret-down",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, i) => (r(), n(d, a(p(e.props)), {
      default: c(() => [l(t.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
